<div class="page-content">

  <!-- ========================================================= -->
  <!-- HEADER -->
  <!-- ========================================================= -->

  <div class="page_header">

    <div class="page_header_text">

      <h1>Clientes</h1>

      <span>
        Gestão de clientes e entidades contratantes
      </span>

    </div>

    <div
      class="page_header_actions"
      style="display: flex; gap: 8px"
    >

      <button
        type="button"
        class="btn-web-secondary"
        (click)="showFilterSidebar = true"
      >
        <i class="ri-filter-3-line"></i>
        Filtros 
      </button>

      <button
        type="button"
        class="btn-web-primary"
        (click)="novoCliente()"
      >
        <i class="fas fa-plus"></i>
        Novo Cliente
      </button>

    </div>

  </div>


  <!-- ========================================================= -->
  <!-- ESTATÍSTICAS -->
  <!-- ========================================================= -->

  <div class="kpi-grid mini">

    <!-- TOTAL -->

    <div class="kpi-card mini">

      <div class="kpi-icon blue">
        <i class="fas fa-building"></i>
      </div>

      <div class="kpi-info">

        <span>Total de Clientes</span>

        <strong>
          {{ totalClientes }}
        </strong>

      </div>

    </div>


    <!-- ACTIVOS -->

    <div class="kpi-card mini">

      <div class="kpi-icon green">
        <i class="fas fa-shield-check"></i>
      </div>

      <div class="kpi-info">

        <span>Activos</span>

        <strong class="green">
          {{ ativos }}
        </strong>

      </div>

    </div>


    <!-- INACTIVOS -->

    <div class="kpi-card mini">

      <div class="kpi-icon yellow">
        <i class="fas fa-pause-circle"></i>
      </div>

      <div class="kpi-info">

        <span>Inactivos</span>

        <strong class="amber">
          {{ inativos }}
        </strong>

      </div>

    </div>


    <!-- SECTORES -->

    <div class="kpi-card mini">

      <div class="kpi-icon purple">
        <i class="fas fa-chart-pie"></i>
      </div>

      <div class="kpi-info">

        <span>Sectores</span>

        <strong>
          {{ sectores }}
        </strong>

      </div>

    </div>

  </div>


  <!-- ========================================================= -->
  <!-- TABELA -->
  <!-- ========================================================= -->

  <div class="data-table-wrapper">

    <!-- SKELETON -->

    <div
      *ngIf="loading"
      class="skeleton-rows"
    >

      <p-skeleton
        *ngFor="let i of [1, 2, 3, 4, 5]"
        height="60px"
        styleClass="mb-2"
      >
      </p-skeleton>

    </div>


    <!-- CONTEÚDO -->

    <ng-container *ngIf="!loading">

      <!-- SEM CLIENTES -->

      <app-empty-state
        *ngIf="
          clientes.length === 0 &&
          activeFilterCount === 0
        "
        icon="fas fa-building"
        title="Nenhum cliente registado"
        message="Registe o primeiro cliente contratante."
        actionLabel="Novo Cliente"
        (action)="novoCliente()"
      >
      </app-empty-state>


      <!-- SEM RESULTADOS -->

      <app-empty-state
        *ngIf="
          clientes.length === 0 &&
          activeFilterCount > 0
        "
        icon="fas fa-search"
        title="Sem resultados"
        message="Nenhum cliente corresponde aos critérios de pesquisa."
      >
      </app-empty-state>


      <!-- TABELA -->

      <table
        class="data-table"
        *ngIf="clientes.length > 0"
      >

        <colgroup>

          <col style="width: 30%" />
          <col style="width: 13%" />
          <col style="width: 10%" />
          <col style="width: 10%" />
          <col style="width: 20%" />
          <col style="width: 11%" />
          <col style="width: 90px" />

        </colgroup>


        <thead>

          <tr>

            <th>Cliente</th>
            <th>Sector</th>
            <th>Contratos</th>
            <th>Estado</th>
            <th>Responsável</th>
            <th>Telefone</th>

            <th class="text-right">
              Acções
            </th>

          </tr>

        </thead>


        <tbody>

          <tr
            *ngFor="let c of clientes"
            class="clickable-row"
            (click)="verDetalhe(c)"
          >

            <!-- CLIENTE -->

            <td>

              <div class="client-cell">

                <div
                  class="client-av"
                  [class.no-photo]="!c.logoUrl"
                  [style.background]="
                    c.logoUrl
                      ? 'none'
                      : getAvatarColor(c.nome)
                  "
                  [pTooltip]="
                    c.logoUrl
                      ? ''
                      : 'Sem fotografia'
                  "
                  tooltipPosition="right"
                >

                  <img
                    *ngIf="c.logoUrl"
                    [src]="c.logoUrl"
                    [alt]="c.nome"
                    class="client-logo"
                    (error)="c.logoUrl = undefined"
                  />

                  <ng-container *ngIf="!c.logoUrl">

                    <i class="fas fa-building av-icon"></i>

                    <span class="av-initials">
                      {{ getInitials(c.nome) }}
                    </span>

                  </ng-container>

                </div>


                <div class="client-meta">

                  <span class="client-nome">
                    {{ c.nome }}
                  </span>

                  <span
                    *ngIf="c.nif"
                    class="client-nif"
                  >
                    {{ c.nif }}
                  </span>

                </div>

              </div>

            </td>


            <!-- SECTOR -->

            <td>

              <span
                *ngIf="c.sector"
                class="sector-badge"
                [ngClass]="getSectorClass(c.sector)"
              >
                {{ getSectorLabel(c.sector) }}
              </span>

              <span
                *ngIf="!c.sector"
                class="text-muted"
              >
                —
              </span>

            </td>


            <!-- CONTRATOS -->

            <td>

              <span
                class="contratos-badge"
                [class.has-contratos]="
                  (c.totalContratosActivos ?? 0) > 0
                "
              >

                <i class="fas fa-file-invoice"></i>

                {{ c.totalContratosActivos ?? 0 }}

              </span>

            </td>


            <!-- ESTADO -->

            <td>

              <span
                class="estado-badge"
                [class.ativo]="c.ativo !== false"
              >

                <i class="fas fa-circle"></i>

                {{
                  c.ativo !== false
                    ? 'Activo'
                    : 'Inactivo'
                }}

              </span>

            </td>


            <!-- RESPONSÁVEL -->

            <td>

              <div
                *ngIf="c.nomeResponsavel; else noResp"
                class="responsavel-cell"
              >

                <i class="fas fa-user-shield"></i>

                {{ c.nomeResponsavel }}

              </div>

              <ng-template #noResp>

                <span class="text-muted">
                  —
                </span>

              </ng-template>

            </td>


            <!-- TELEFONE -->

            <td>
              {{ c.numTelefone || '—' }}
            </td>


            <!-- ACÇÕES -->

            <td
              class="actions"
              (click)="$event.stopPropagation()"
            >

              <p-menu
                #rowMenu
                [model]="menuItems"
                [popup]="true"
                appendTo="body"
              >
              </p-menu>

              <button
                type="button"
                class="btn-dots"
                (click)="
                  openRowMenu(
                    $event,
                    c,
                    rowMenu
                  )
                "
                pTooltip="Acções"
                tooltipPosition="left"
              >

                <i class="fas fa-ellipsis-v"></i>

              </button>

            </td>

          </tr>

        </tbody>

      </table>


      <!-- PAGINAÇÃO -->

      <br />

      <p-paginator
        [alwaysShow]="true"
        [rows]="pageSize"
        [totalRecords]="totalRecords"
        [rowsPerPageOptions]="[
          10,
          15,
          25,
          50
        ]"
        [first]="
          (currentPage - 1) * pageSize
        "
        (onPageChange)="onPageChange($event)"
        styleClass="sp-paginator"
      >
      </p-paginator>

    </ng-container>

  </div>


  <!-- ========================================================= -->
  <!-- FILTROS OVERLAY -->
  <!-- ========================================================= -->

  <div
    class="filtros-overlay"
    [class.open]="showFilterSidebar"
    (click)="showFilterSidebar = false"
  >
  </div>


  <!-- ========================================================= -->
  <!-- FILTROS DRAWER -->
  <!-- ========================================================= -->

  <div
    class="filtros-drawer"
    [class.open]="showFilterSidebar"
  >

    <div class="filtros-header">

      <h3 class="fd-title">
        <i class="ri-equalizer-3-line"></i>Filtros de Clientes
      </h3>

      <button
        type="button"
        class="filtros-close-btn"
        (click)="showFilterSidebar = false"
      >

        <i class="fas fa-times"></i>

      </button>

    </div>


    <div
      class="filtros-body"
      [formGroup]="filtrosForm"
    >

      <!-- NOME -->

      <div class="filtro-grupo">

        <label>Nome</label>

        <input
          type="text"
          formControlName="Nome"
          class="form-input"
          placeholder="Ex: Empresa Lda..."
        />

      </div>


      <!-- NIF -->

      <div class="filtro-grupo">

        <label>NIF</label>

        <input
          type="text"
          formControlName="Nif"
          class="form-input"
          placeholder="Ex: 5410003691"
        />

      </div>


      <!-- TELEFONE -->

      <div class="filtro-grupo">

        <label>Telefone</label>

        <input
          type="text"
          formControlName="NumTelefone"
          class="form-input"
          placeholder="Ex: 923000000"
        />

      </div>


      <!-- RESPONSÁVEL -->

      <div class="filtro-grupo">

        <label>Responsável</label>

        <input
          type="text"
          formControlName="NomeResponsavel"
          class="form-input"
          placeholder="Nome do responsável"
        />

      </div>


      <!-- EMAIL -->

      <div class="filtro-grupo">

        <label>E-mail</label>

        <input
          type="email"
          formControlName="Email"
          class="form-input"
          placeholder="geral@..."
        />

      </div>


      <!-- SECTOR -->

      <div class="filtro-grupo">

        <label>
          Sector de Actividade
        </label>

        <p-select
          formControlName="SetorAtividadeEmpresaEnum"
          [options]="sectors"
          optionLabel="label"
          optionValue="enumValue"
          placeholder="Todos os sectores"
          [showClear]="true"
          styleClass="w-full"
          appendTo="body"
        >
        </p-select>

      </div>


      <!-- ESTADO -->

      <div class="filtro-grupo">

        <label>Estado</label>

        <p-select
          formControlName="IsActive"
          [options]="estadoOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="Todos"
          [showClear]="true"
          styleClass="w-full"
          appendTo="body"
        >
        </p-select>

      </div>

    </div>


    <!-- FOOTER -->

    <div class="filtros-footer">

      <button
        type="button"
        class="btn-web-secondary"
        style="flex: 1"
        (click)="$event.preventDefault(); $event.stopPropagation(); clearFilters()"
      >

        <i class="fas fa-undo"></i>

        Limpar

      </button>

      <button
        type="button"
        class="btn-web-primary"
        style="flex: 2"
        (click)="applyFilters()"
      >

        <i class="fas fa-check"></i>

        Aplicar

        <span
          *ngIf="activeFilterCount > 0"
        >
          ({{ activeFilterCount }})
        </span>

      </button>

    </div>

  </div>


  <!-- ========================================================= -->
  <!-- INPUT LOGOTIPO -->
  <!-- ========================================================= -->

  <input
    #fileInput
    type="file"
    accept="image/*"
    hidden
    (change)="onLogoChange($event)"
  />


  <!-- ========================================================= -->
  <!-- DRAWER EDITAR CLIENTE -->
  <!-- ========================================================= -->

  <p-drawer
    header="Editar Cliente"
    [(visible)]="showDialog"
    position="right"
    [modal]="true"
    [style]="{
      width: '720px'
    }"
    styleClass="efetivo-drawer-dark"
  >

    <form
      [formGroup]="form"
      class="dialog-form"
    >

      <!-- ===================================================== -->
      <!-- IDENTIFICAÇÃO -->
      <!-- ===================================================== -->

      <div class="form-top-row">

        <!-- LOGOTIPO -->

        <div
          class="logo-zone"
          (click)="triggerLogoInput()"
          pTooltip="Clique para alterar logotipo"
          tooltipPosition="right"
        >

          <img
            *ngIf="logoPreview"
            [src]="logoPreview"
            class="logo-img"
            alt="Logotipo"
          />

          <div
            *ngIf="!logoPreview"
            class="logo-empty"
          >

            <i class="fas fa-image"></i>

            <span>
              Logotipo
            </span>

          </div>

          <div class="logo-overlay">

            <i class="fas fa-camera"></i>

          </div>

        </div>


        <!-- IDENTIFICAÇÃO -->

        <div class="form-ident">

          <!-- NOME -->

          <div class="form-group">

            <label>
              Nome da Empresa / Cliente
              <span class="req">*</span>
            </label>

            <input
              class="form-input"
              formControlName="nome"
              placeholder="Ex: Banco BFA, S.A."
              [class.is-error]="
                f['nome'].invalid &&
                f['nome'].touched
              "
            />

            <ng-container
              *ngIf="
                f['nome'].invalid &&
                f['nome'].touched
              "
            >

              <span
                *ngIf="
                  f['nome'].hasError('required')
                "
                class="sp-error"
              >

                <i class="fas fa-exclamation-triangle"></i>

                O nome é obrigatório.

              </span>

              <span
                *ngIf="
                  f['nome'].hasError('minlength')
                "
                class="sp-error"
              >

                <i class="fas fa-exclamation-triangle"></i>

                Mínimo 2 caracteres

              </span>

            </ng-container>

          </div>


          <!-- NIF -->

          <div class="form-group">

            <label>
              NIF Fiscal
              <span class="req">*</span>
            </label>

            <div class="nif-search-row">

              <input
                class="form-input"
                formControlName="nif"
                placeholder="Ex: 5410003691"
                [class.is-error]="
                  f['nif'].invalid &&
                  f['nif'].touched
                "
              />

              <button
                type="button"
                class="btn-nif"
                (click)="searchNif()"
                [disabled]="nifSearching"
              >

                <i
                  [class]="
                    nifSearching
                      ? 'fas fa-spinner fa-spin'
                      : 'fas fa-search'
                  "
                ></i>

                {{
                  nifSearching
                    ? 'A pesquisar...'
                    : 'Pesquisar NIF'
                }}

              </button>

            </div>

            <ng-container
              *ngIf="
                f['nif'].invalid &&
                f['nif'].touched
              "
            >

              <span
                *ngIf="
                  f['nif'].hasError('required')
                "
                class="sp-error"
              >

                <i class="fas fa-exclamation-triangle"></i>

                O NIF é obrigatório.

              </span>

              <span
                *ngIf="
                  f['nif'].hasError('pattern')
                "
                class="sp-error"
              >

                <i class="fas fa-exclamation-triangle"></i>

                Apenas letras e números,
                sem espaços

              </span>

              <span
                *ngIf="
                  f['nif'].hasError('minlength')
                "
                class="sp-error"
              >

                <i class="fas fa-exclamation-triangle"></i>

                Mínimo 8 caracteres

              </span>

            </ng-container>

          </div>

        </div>

      </div>


      <div class="form-divider"></div>


      <!-- ===================================================== -->
      <!-- INFORMAÇÃO COMERCIAL -->
      <!-- ===================================================== -->

      <p class="form-section-title">

        <i class="fas fa-briefcase"></i>

        Informação Comercial

      </p>


      <div class="form-grid-2">

        <!-- SECTOR -->

        <div class="form-group">

          <label>
            Sector de Actividade
          </label>

          <p-select
            formControlName="sector"
            [options]="sectors"
            optionLabel="label"
            optionValue="value"
            placeholder="Seleccionar sector"
            styleClass="w-full"
            appendTo="body"
          >
          </p-select>

        </div>


        <!-- WEBSITE -->

        <div class="form-group">

          <label>
            Website
            <span class="req">*</span>
          </label>

          <div class="input-prefix-wrap">

            <span class="input-prefix">

              <i class="fas fa-globe"></i>

            </span>

            <input
              class="form-input prefixed"
              formControlName="website"
              placeholder="www.empresa.ao"
              [class.is-error]="
                f['website'].invalid &&
                f['website'].touched
              "
            />

          </div>

          <ng-container
            *ngIf="
              f['website'].invalid &&
              f['website'].touched
            "
          >

            <span
              *ngIf="
                f['website'].hasError('required')
              "
              class="sp-error"
            >

              <i class="fas fa-exclamation-triangle"></i>

              O website é obrigatório.

            </span>

            <span
              *ngIf="
                f['website'].hasError('pattern')
              "
              class="sp-error"
            >

              <i class="fas fa-exclamation-triangle"></i>

              URL inválido
              (ex: www.empresa.ao)

            </span>

          </ng-container>

        </div>

      </div>


      <div class="form-divider"></div>


      <!-- ===================================================== -->
      <!-- INFORMAÇÃO DE CONTACTO -->
      <!-- ===================================================== -->

      <p class="form-section-title">

        <i class="fas fa-address-book"></i>

        Informação de Contacto

      </p>


      <div class="form-grid-2">

        <!-- TELEFONE -->

        <div class="form-group">

          <label>
            Telefone
            <span class="req">*</span>
          </label>

          <div class="input-prefix-wrap">

            <span class="input-prefix">

              <i class="fas fa-phone"></i>

            </span>

            <input
              class="form-input prefixed"
              type="tel"
              formControlName="numTelefone"
              placeholder="923 000 000"
              [class.is-error]="
                f['numTelefone'].invalid &&
                f['numTelefone'].touched
              "
            />

          </div>

          <ng-container
            *ngIf="
              f['numTelefone'].invalid &&
              f['numTelefone'].touched
            "
          >

            <span
              *ngIf="
                f['numTelefone'].hasError('required')
              "
              class="sp-error"
            >

              <i class="fas fa-exclamation-triangle"></i>

              O número de telefone é obrigatório.

            </span>

            <span
              *ngIf="
                f['numTelefone'].hasError('pattern')
              "
              class="sp-error"
            >

              <i class="fas fa-exclamation-triangle"></i>

              Apenas dígitos, espaços
              ou + ( ) —

            </span>

          </ng-container>

        </div>


        <!-- EMAIL -->

        <div class="form-group">

          <label>
            E-mail
            <span class="req">*</span>
          </label>

          <div class="input-prefix-wrap">

            <span class="input-prefix">

              <i class="fas fa-envelope"></i>

            </span>

            <input
              class="form-input prefixed"
              type="email"
              formControlName="email"
              placeholder="geral@empresa.ao"
              [class.is-error]="
                f['email'].invalid &&
                f['email'].touched
              "
            />

          </div>

          <ng-container
            *ngIf="
              f['email'].invalid &&
              f['email'].touched
            "
          >

            <span
              *ngIf="
                f['email'].hasError('required')
              "
              class="sp-error"
            >

              <i class="fas fa-exclamation-triangle"></i>

              O e-mail é obrigatório.

            </span>

            <span
              *ngIf="
                f['email'].hasError('email')
              "
              class="sp-error"
            >

              <i class="fas fa-exclamation-triangle"></i>

              Formato de e-mail
              inválido

            </span>

          </ng-container>

        </div>


        <!-- RESPONSÁVEL -->

        <div class="form-group">

          <label>
            Nome do Responsável
            <span class="req">*</span>
          </label>

          <div class="input-prefix-wrap">

            <span class="input-prefix">

              <i class="fas fa-user-shield"></i>

            </span>

            <input
              class="form-input prefixed"
              formControlName="nomeResponsavel"
              placeholder="Nome completo"
              [class.is-error]="
                f['nomeResponsavel'].invalid &&
                f['nomeResponsavel'].touched
              "
            />

          </div>

          <span
            *ngIf="
              f['nomeResponsavel'].hasError('required') &&
              f['nomeResponsavel'].touched
            "
            class="sp-error"
          >

            <i class="fas fa-exclamation-triangle"></i>

            O nome do responsável é obrigatório.

          </span>

        </div>


        <!-- ENDEREÇO -->

        <div class="form-group">

          <label>
            Endereço
            <span class="req">*</span>
          </label>

          <div class="input-prefix-wrap">

            <span class="input-prefix">

              <i class="fas fa-map-marker-alt"></i>

            </span>

            <input
              class="form-input prefixed"
              formControlName="endereco"
              placeholder="Rua, nº, município"
              [class.is-error]="
                f['endereco'].invalid &&
                f['endereco'].touched
              "
            />

          </div>

          <span
            *ngIf="
              f['endereco'].hasError('required') &&
              f['endereco'].touched
            "
            class="sp-error"
          >

            <i class="fas fa-exclamation-triangle"></i>

            O endereço é obrigatório.

          </span>

        </div>

      </div>

    </form>


    <!-- ===================================================== -->
    <!-- FOOTER -->
    <!-- ===================================================== -->

    <ng-template pTemplate="footer">

      <button
        type="button"
        class="btn-web-secondary"
        (click)="showDialog = false"
      >
        Cancelar
      </button>

      <button
        type="button"
        class="btn-web-primary"
        (click)="save()"
      >

        <i class="fas fa-save"></i>

        Guardar

      </button>

    </ng-template>

  </p-drawer>

</div>
